import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppStateInterface } from '@app/core/app-services';
import { Language, Languages, LanguageIdentifier } from '@app/core/models';
import { AppStateStore } from './app.store';
import { AppStateQuery } from './app.query';

@Injectable()
export class AppState implements AppStateInterface {

  constructor(
    private store: AppStateStore,
    private query: AppStateQuery
  ) { }

  isAuthenticated(): Observable<boolean> {
    return this.query.select(state => state.authenticated);
  }

  getLanguage(): Observable<Language> {
    return this.query
      .select(state => state.language)
      .pipe(map((identifier: LanguageIdentifier) => Languages[identifier]));
  }

  setAuthenticated(status: boolean): void {
    this.store.update(state => ({ ...state, authenticated: status }));
  }

  setLanguage(lang: Language): void {
    this.store.update(state => ({ ...state, language: lang.identifier }));
  }

  getError(): Observable<boolean> {
    return this.query.select(state => state.error);
  }

  setError(): void {
    this.store.update(state => ({ ...state, error: true }));
  }

  resetError(): void {
    this.store.update(state => ({ ...state, error: false }));
  }
}
